import Marionette from 'backbone.marionette';
import Navigator from 'app';
import billController from './bills_controller';
var BillRouter = Marionette.AppRouter.extend({
  appRoutes: {
    "bills": "showBillHome",
    "bills/category/:category": "showWatchedBillCategory",
    "bills/search/:searchtext": "searchBillText",
    "bills/list/:list": "showBillList",
    "bills/:id": "showBillDetail",
    "bills/:doctype/:number": "showBillByNumber"
  }
});
var API = {
  showBillHome: function () {
    billController.showBillHome();
    // Navigator.updateAnalytics("bills");
  },

  showWatchedBillCategory: function (category) {
    billController.showWatchedBillCategory(category);
    // Navigator.updateAnalytics("bills", "category/" + category);
  },

  showBillDetail: function (id) {
    billController.showBillDetail(id);
    // Navigator.updateAnalytics("bills", id);
  },

  showBillByNumber: function (doctype, number) {
    billController.showBillDetail(doctype + '/' + number);
    // Navigator.updateAnalytics("bills", doctype + '/' + number);
  },

  /** this is currently not in use */
  searchBillText: function (params) {
    billController.showSearchResults(params);
    // Navigator.updateAnalytics("bills", "search" + '/'+ params); //logging this URL for pageviews even though those URLs are never hit (I think they should be) - EM
  },

  showBillList: function (list) {
    billController.showBillList(list);
    // Navigator.updateAnalytics("bills", "list" + '/' + list);
  }
};

Navigator.vent.on("bill:home:show", function () {
  Navigator.navigate("bills");
  API.showBillHome();
});
Navigator.vent.on("bill:home:search", function (params) {
  Navigator.navigate("bills/search/" + params);
  API.searchBillText(params);
});
Navigator.vent.on("bill:category:show", function (category) {
  // FIXME: This never gets triggered, I think because the watched bill categories are links instea of a collection view
  Navigator.navigate("bills/category/" + category);
  API.showWatchedBillCategory(category);
});
Navigator.vent.on("bill:detail:show", function (param) {
  Navigator.navigate("bills/" + param);
  API.showBillDetail(param);
});
Navigator.vent.on("bills:list", function (list) {
  Navigator.navigate("bills/list/" + list);
  API.showBillList(list);
});
Navigator.on("before:start", function () {
  new BillRouter({
    controller: API
  });
});
export { BillRouter as default };